export const DEAL_ASSIGNMENT_TYPES = {
  1: 'Contractor',
  2: 'Perm. Placement'
}

export const CONTRACTOR = 1
export const PERMANENT_PLACEMENT = 2
